export const AGGREGATION_MODES = { aggregate: 'aggregate', ignore: 'ignore', createNew: 'createNew' };
export const debug = false;

const ruleImplementations = {
  /**
   * Create a new item since it will be the first item
   * @param aggregatedDa - aggregated duty activity
   * @param da - current duty activity
   * @returns {{isRuleMatch: boolean, aggregationMode: string}} - isRuleMatch is true to indicate a rule match and aggregationMode is undefined if no rule match or one of aggregate, ignore, createNew
   */
  createNewAggregationWhenUndefined(aggregatedDa, da) {
    let isRuleMatch = false;
    let aggregationMode, appliedRule;

    if (!aggregatedDa) {
      isRuleMatch = true;
      aggregationMode = AGGREGATION_MODES.createNew;
      appliedRule = 'createNewAggregationWhenUndefined';
    }
    return { isRuleMatch, aggregationMode, appliedRule };
  },
  /**
   * Split the block if it contains two following Activities with the value 'WEGE'.
   * In this case it indicates that the driver has to move from one vehicle to another.
   * @param aggregatedDa - aggregated duty activity
   * @param da - current duty activity
   * @returns {{isRuleMatch: boolean, aggregationMode: string}} - isRuleMatch is true to indicate a rule match and aggregationMode is undefined if no rule match or one of aggregate, ignore, createNew
   */
  splitIfTwoWaysFollow(aggregatedDa, da) {
    let isRuleMatch = false;
    let aggregationMode, appliedRule;

    if (aggregatedDa.activityShortname === 'Wege' && da.activityShortname === 'Wege') {
      //
      // 1. Split the block if it contains two following Activities with the value 'WEGE'.
      // In this case it indicates that the driver has to move from one vehicle to another.
      if (debug) console.debug("Split the block if it contains two following Activities with the value 'WEGE'");
      isRuleMatch = true;
      aggregationMode = AGGREGATION_MODES.createNew;
      appliedRule = 'splitIfTwoWaysFollow';
    }
    return { isRuleMatch, aggregationMode, appliedRule };
  },
  /**
   * 2. Split the block if the Activity name changes from 'UMLSTK' to something else.
   * This indicates that the shift on the current vehicle ends.
   * @param aggregatedDa - aggregated duty activity
   * @param da - current duty activity
   * @returns {{isRuleMatch: boolean, aggregationMode: string}} - isRuleMatch is true to indicate a rule match and aggregationMode is undefined if no rule match or one of aggregate, ignore, createNew
   */
  splitIfActivityChangesFromUmlaufToSomethingOther(aggregatedDa, da) {
    let isRuleMatch = false;
    let aggregationMode, appliedRule;

    if (aggregatedDa.activityShortname === 'Umlstk' && da.activityShortname !== 'Umlstk') {
      if (debug) console.debug("Split the block if the Activityname changes from 'UMLSTK' to something else");
      isRuleMatch = true;
      aggregationMode = AGGREGATION_MODES.createNew;
      appliedRule = 'splitIfActivityChangesFromUmlaufToSomethingOther';
    }
    return { isRuleMatch, aggregationMode, appliedRule };
  },
  /**
   * 2.1 Split the block if the Activity name changes
   * This indicates that the shift on the current vehicle ends.
   * @param aggregatedDa - aggregated duty activity
   * @param da - current duty activity
   * @returns {{isRuleMatch: boolean, aggregationMode: string}} - isRuleMatch is true to indicate a rule match and aggregationMode is undefined if no rule match or one of aggregate, ignore, createNew
   */
  splitIfActivityChanges(aggregatedDa, da) {
    let isRuleMatch = false;
    let aggregationMode, appliedRule;

    if (aggregatedDa.activityShortname !== da.activityShortname) {
      if (debug) console.debug('Split the block if the Activityname changes');
      isRuleMatch = true;
      aggregationMode = AGGREGATION_MODES.createNew;
      appliedRule = 'splitIfActivityChanges';
    }
    return { isRuleMatch, aggregationMode, appliedRule };
  },
  /**
   * 2.2 Split the block if to-time of the last duty activity is not linked to the from of the current
   * @param aggregatedDa - aggregated duty activity
   * @param da - current duty activity
   * @returns {{isRuleMatch: boolean, aggregationMode: string}} - isRuleMatch is true to indicate a rule match and aggregationMode is undefined if no rule match or one of aggregate, ignore, createNew
   */
  splitIfEndNotLinkedToNextStartTime(aggregatedDa, da) {
    let isRuleMatch = false;
    let aggregationMode, appliedRule;

    const diff = aggregatedDa.toMinutesAfterMidnight - da.fromMinutesAfterMidnight;
    if (diff !== 1440 && diff !== 0) {
      if (debug)
        console.debug(
          `Split the block if the toMinutesAfterMidnight (${aggregatedDa.toMinutesAfterMidnight}) not equals to fromMinutesAfterMidnight ${da.fromMinutesAfterMidnight}`
        );
      isRuleMatch = true;
      aggregationMode = AGGREGATION_MODES.createNew;
      appliedRule = 'splitIfEndNotLinkedToNextStartTime';
    }
    return { isRuleMatch, aggregationMode, appliedRule };
  },
  /**
   * 3. Split the block if the course changes.
   * This indicates that the driver changes the vehicle or that the vehicle will change it's course.
   * @param aggregatedDa - aggregated duty activity
   * @param da - current duty activity
   * @returns {{isRuleMatch: boolean, aggregationMode: string}} - isRuleMatch is true to indicate a rule match and aggregationMode is undefined if no rule match or one of aggregate, ignore, createNew
   */
  splitIfCourseChanges(aggregatedDa, da) {
    let isRuleMatch = false;
    let aggregationMode, appliedRule;

    // if (aggregatedDa.course !== null && da.course !== aggregatedDa.course && aggregatedDa.activityShortname !== da.activityShortname) {
    // if (aggregatedDa.course && da.course !== aggregatedDa.course ) {
    if (aggregatedDa.course && da.course !== aggregatedDa.course) {
      if (debug) console.debug(`Split the block if the course changes from ${aggregatedDa.course} to ${da.course} and has got a different activityShortname`);

      isRuleMatch = true;
      aggregationMode = AGGREGATION_MODES.createNew;
      appliedRule = 'splitIfCourseChanges';
    }
    return { isRuleMatch, aggregationMode, appliedRule };
  },
  /**
   * 4. Aggregate all directly following 'UMLSTK' activities into one activity where the start-location and start-time
   * comes from the first activity and the end-location and end-time comes from the last activity
   *
   * @param aggregatedDa - aggregated duty activity
   * @param da - current duty activity
   * @returns {{isRuleMatch: boolean, aggregationMode: string}} - isRuleMatch is true to indicate a rule match and aggregationMode is undefined if no rule match or one of aggregate, ignore, createNew
   */
  aggregateSubsequentNullBlockcodes(aggregatedDa, da) {
    let isRuleMatch = false;
    let aggregationMode, appliedRule;
    const isBlockcodeNull = !da.blockcode;
    const isCourseChangedToOtherValue = !!aggregatedDa.course && !!da.course && aggregatedDa.course !== da.course;
    if (isBlockcodeNull && !isCourseChangedToOtherValue) {
      if (debug) console.debug('Aggregate aggregateSubsequentNullBlockcodes');
      isRuleMatch = true;
      aggregationMode = AGGREGATION_MODES.aggregate;
      appliedRule = 'aggregateSubsequentNullBlockcodes';
    }
    return { isRuleMatch, aggregationMode, appliedRule };
  },
  /**
   * 4. Aggregate all directly following 'UMLSTK' activities into one activity where the start-location and start-time
   * comes from the first activity and the end-location and end-time comes from the last activity
   *
   * @param aggregatedDa - aggregated duty activity
   * @param da - current duty activity
   * @returns {{isRuleMatch: boolean, aggregationMode: string}} - isRuleMatch is true to indicate a rule match and aggregationMode is undefined if no rule match or one of aggregate, ignore, createNew
   */
  aggregateOnSubsequentUmlauf(aggregatedDa, da) {
    let isRuleMatch = false;
    let aggregationMode, appliedRule;
    const isDefinedCourseAndLineAfterUndefinedOnes = !aggregatedDa.course && !aggregatedDa.line && !!da.course && !!da.line;
    // const isUndefinedCourseAndLineAfterDefinedOnes = !!aggregatedDa.course && !!aggregatedDa.line && !da.course && !da.line; // OLD
    const isUndefinedCourseAndLineAfterDefinedOnes = (!!aggregatedDa.course || !!aggregatedDa.line) && !da.course && !da.line;
    const isSameCourseAndLine = aggregatedDa.course === da.course && aggregatedDa.line === da.line;

    const isSubsequentUmlaufStueck = aggregatedDa.activityShortname === da.activityShortname && da.activityShortname === 'Umlstk';

    if (isSubsequentUmlaufStueck && (isDefinedCourseAndLineAfterUndefinedOnes || isUndefinedCourseAndLineAfterDefinedOnes || isSameCourseAndLine)) {
      // if (debug) {
      //   console.debug("Aggregate all directly following 'UMLSTK' activities into one activity");
      //   console.debug(`isSubsequentUmlaufStueck=${isSubsequentUmlaufStueck}`);
      //   console.debug('-----  ');
      //   console.debug(`isDefinedCourseAndLineAfterUndefinedOnes=${isDefinedCourseAndLineAfterUndefinedOnes}`);
      //   console.debug(`isUndefinedCourseAndLineAfterDefinedOnes=${isUndefinedCourseAndLineAfterDefinedOnes}`);
      //   console.debug(`isSameCourseAndLine=${isSameCourseAndLine}`);
      // }
      isRuleMatch = true;
      aggregationMode = AGGREGATION_MODES.aggregate;
      appliedRule = 'aggregateOnSubsequentUmlauf';
    }
    return { isRuleMatch, aggregationMode, appliedRule };
  },

  /**
   * More general rule to be applied when subsequent activities and courses are the same
   *
   * @param aggregatedDa - aggregated duty activity
   * @param da - current duty activity
   * @returns {{isRuleMatch: boolean, aggregationMode: string}} - isRuleMatch is true to indicate a rule match and aggregationMode is undefined if no rule match or one of aggregate, ignore, createNew
   */
  aggregateOnSubsequentActivityAndCourse(aggregatedDa, da) {
    let isRuleMatch = false;
    let aggregationMode, appliedRule;

    if (aggregatedDa.activityShortname === da.activityShortname && da.course === aggregatedDa.course) {
      if (debug) console.debug(`Aggregate all when activityShortname=${da.activityShortname} and course ${da.course}  is same as before`);
      isRuleMatch = true;
      aggregationMode = AGGREGATION_MODES.aggregate;
      appliedRule = 'aggregateOnSubsequentActivityAndCourse';
    }
    return { isRuleMatch, aggregationMode, appliedRule };
  },

  /**
   * Rule additional to https://bitbucket.org/innotix/nxg_interface/src/main/services/interface/src/adapters/aggregate/vbz/dutyactivity_to_meindienst.md
   * This is a required additional rule to aggregate/ignore items with equal start and stop location
   *
   * @param aggregatedDa - aggregated duty activity
   * @param da - current duty activity
   * @returns {{isRuleMatch: boolean, aggregationMode: string}} - isRuleMatch is true to indicate a rule match and aggregationMode is undefined if no rule match or one of aggregate, ignore, createNew
   */
  aggregateWhenStartStopAreUnique(aggregatedDa, da) {
    let isRuleMatch = false;
    let aggregationMode, appliedRule;

    if (da.startStopIdFk === da.endStopIdFk) {
      if (debug) console.debug('Additional aggregation Rule: ignore items with equal start and stop location');
      isRuleMatch = true;
      aggregationMode = AGGREGATION_MODES.ignore;
      appliedRule = 'aggregateWhenStartStopAreUnique';
    }
    return { isRuleMatch, aggregationMode, appliedRule };
  },
  /**
   * Rule additional to https://bitbucket.org/innotix/nxg_interface/src/main/services/interface/src/adapters/aggregate/vbz/dutyactivity_to_meindienst.md
   * This is a required rule to aggregate/ignore items with equal from and to time
   *
   * @param aggregatedDa - aggregated duty activity
   * @param da - current duty activity
   * @returns {{isRuleMatch: boolean, aggregationMode: string}} - isRuleMatch is true to indicate a rule match and aggregationMode is undefined if no rule match or one of aggregate, ignore, createNew
   */
  aggregateWhenFromAndToAreUnique(aggregatedDa, da) {
    let isRuleMatch = false;
    let aggregationMode, appliedRule;

    if (da.fromMinutesAfterMidnight === da.toMinutesAfterMidnight) {
      if (debug) console.debug('Additional aggregation Rule: This is a required rule to aggregate/ignore items with equal from and to times');
      isRuleMatch = true;
      aggregationMode = AGGREGATION_MODES.ignore;
      appliedRule = 'aggregateWhenFromAndToAreUnique';
    }
    return { isRuleMatch, aggregationMode, appliedRule };
  },
  /**
   * Rule additional to https://bitbucket.org/innotix/nxg_interface/src/main/services/interface/src/adapters/aggregate/vbz/dutyactivity_to_meindienst.md
   * This is a required rule to aggregate/ignore when course and line are null
   *
   * @param aggregatedDa - aggregated duty activity
   * @param da - current duty activity
   * @returns {{isRuleMatch: boolean, aggregationMode: string}} - isRuleMatch is true to indicate a rule match and aggregationMode is undefined if no rule match or one of aggregate, ignore, createNew
   */
  aggregateWhenUndefinedCourseAndLine(aggregatedDa, da) {
    let isRuleMatch = false;
    let aggregationMode, appliedRule;

    if (!da.course && !da.line) {
      if (debug) console.debug('Aggregation Rule: Aggregate when course and line are null');
      isRuleMatch = true;
      aggregationMode = AGGREGATION_MODES.aggregate;
      appliedRule = 'aggregateWhenUndefinedCourseAndLine';
    }
    return { isRuleMatch, aggregationMode, appliedRule };
  },

  /**
   * Defaults to split when no other rule applies
   *
   * @param aggregatedDa - aggregated duty activity
   * @param da - current duty activity
   * @returns {{isRuleMatch: boolean, aggregationMode: string}} - isRuleMatch is true to indicate a rule match and aggregationMode is undefined if no rule match or one of aggregate, ignore, createNew
   */
  defaultRule(aggregatedDa, da) {
    let isRuleMatch = false;
    let aggregationMode, appliedRule;

    if (debug) console.debug('Default: split');
    isRuleMatch = true;
    aggregationMode = AGGREGATION_MODES.createNew;
    appliedRule = 'defaultRule';
    return { isRuleMatch, aggregationMode, appliedRule };
  },
};

export default ruleImplementations;

export const vbzAggregationRules = [
  ruleImplementations.createNewAggregationWhenUndefined,

  // 1. Split the block if it contains two following Activities with the value 'WEGE'.
  // In this case it indicates that the driver has to move from one vehicle to another.
  ruleImplementations.splitIfTwoWaysFollow,

  // 2. Split the block if the Activityname changes from 'UMLSTK' to something else.
  // This indicates that the shift on the current vehicle ends.
  ruleImplementations.splitIfActivityChangesFromUmlaufToSomethingOther,

  // 2.1 Split the block if the Activityname changes
  // This indicates that the shift on the current vehicle ends.
  ruleImplementations.splitIfActivityChanges,
  ruleImplementations.splitIfEndNotLinkedToNextStartTime,

  ruleImplementations.aggregateSubsequentNullBlockcodes,
  // 4. More general rule to be applied when subsequent activites and courses are the same
  // Additional but necessary rule
  ruleImplementations.aggregateOnSubsequentUmlauf,

  // 3. Split the block if the course changes.
  // This indicates that the driver changes the vehicle or that the vehicle will change it's course.
  ruleImplementations.splitIfCourseChanges,

  // More general rule to be applied when subsequent activites and courses are the same
  ruleImplementations.aggregateOnSubsequentActivityAndCourse,

  // This is a required rule to aggregate/ignore when course and line are null
  ruleImplementations.aggregateWhenUndefinedCourseAndLine,

  // This is a required additional rule to aggregate/ignore items with equal start and stop location
  ruleImplementations.aggregateWhenStartStopAreUnique,

  // This is a required rule to aggregate/ignore items with equal from and to time
  ruleImplementations.aggregateWhenFromAndToAreUnique,

  // default
  ruleImplementations.defaultRule,
];
// export function logDebugInfo(aggregatedDa, da) {
//   if (debug && aggregatedDa) {
//     console.debug(
//       'runningDa',
//       JSON.stringify({
//         line: aggregatedDa.line,
//         course: aggregatedDa.course,
//         from: aggregatedDa.from,
//         to: aggregatedDa.to,
//         activityShortname: aggregatedDa.activityShortname,
//       })
//     );
//   }
//   if (debug)
//     console.debug(
//       '       da',
//       JSON.stringify({
//         line: da.line,
//         course: da.course,
//         from: da.from,
//         to: da.to,
//         activityShortname: da.activityShortname,
//       })
//     );
// }
